import React, { memo, useMemo } from 'react';
import HeaderCell from './headerCell';
import { CustomerPriceSelectors } from '../../../../store/selectors/customerPriceSelectors';

const HeaderRow = ({ resource, checkedList, setCheckedList, priceListIDs, allChecked, setAllChecked }) => {
    const { state } = CustomerPriceSelectors();
    const headers = useMemo(() => state[resource].headers, [state, resource]);

    const headerStyle = useMemo(() => ({
        height: '32px',
        fontSize: '12px',
    }), []);

    return (
        <div className='resp-table-header'
            style={headerStyle}>
            {headers.map((header, ind) => {
                return <HeaderCell 
                            key={header.id} 
                            ind={ind} 
                            resource={resource} 
                            priceListIDs={priceListIDs}
                            allChecked={allChecked}
                            setAllChecked={setAllChecked}
                            setCheckedList={setCheckedList}
                            checkedList={checkedList}
                        />
            })}
        </div>
    );
};

export default memo (HeaderRow);